<template>
  <div>
  <div>
    <vs-input
      v-validate="'required|email|min:3'"
      data-vv-validate-on="blur"
      name="email"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      :label-placeholder="$t('login.lbl1')"
      v-model="email"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>

    <vs-input
      data-vv-validate-on="blur"
      v-validate="'required'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      :label-placeholder="$t('login.lbl2')"
      v-model="password"
      class="w-full mt-6"
      v-on:keyup.enter="onEnter"
    />
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>

    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
        >{{$t('login.lbl3')}}</vs-checkbox
      >
      <p    class="small" @click="ForgetPasswordPrompt = true"
      >{{$t('login.lbl4')}}</p
      >
      <!--<router-link to="/user/auth/forgot-password">Forgot Password?</router-link>-->
    </div>
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :disabled="!validateForm" :color="validateForm ? 'success' : 'primary'" @click="loginJWT">{{$t('login.btn1')}}</vs-button>
<!--      <vs-button type="border" @click="registerUser" target href="https://gtbrdd.typeform.com/to/gNOoQ6">Request Access</vs-button>-->
    </div>

  </div>
    <div class="flex flex-wrap justify-between mb-3">

      <vs-prompt
        color="primary"
        :title="$t('login.lbl4')"
        :accept-text="$t('Submit')"
        :cancel-text="$t('Cancel')"
        @cancel="forget_password_email=''"
        @accept="forget_password"
        @close="forget_password_email='', ForgetPasswordPrompt = false"
        :active.sync="ForgetPasswordPrompt"
      >
        <vs-input
          size="large"
          v-validate="'required|email'"
          name="email"
          v-model="forget_password_email"
          class="w-full mb-6"
          icon-pack="feather"
          icon="icon-mail"
          icon-no-border

        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
        errors.first("email")
      }}</span>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies';
import i18n from "@/i18n/i18n";
export default {
  data () {
    return {
      email: "",
      password: "",
      forget_password_email:"",
      checkbox_remember_me: false,
      ForgetPasswordPrompt: false,
    };
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== "" && this.password !== "";
    },

  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.userAuth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: i18n.t('notification.user.auth.checkLogin.warning.w1'),
          text:  i18n.t('notification.user.auth.checkLogin.warning.w2'),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },
    onEnter(){
     this.loginJWT();
    },
    loginJWT () {
      if (!this.checkLogin()) return;

      // Loading
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
          companyPassword: this.password
        }
      };

      this.$store
        .dispatch("userAuth/loginJWT", payload)
        .then((res) => {
          this.$vs.loading.close();
          console.log("login success", res)
           // this.$router.push({name: 'admin-user-list'})

          if(res.data){
            this.$router.push({name: 'admin-user-list'});
          }
          else {

            if (res.user.userType === "trainee") {

              this.$store
                  .dispatch("addSkill/findCompetency", {query: {usersId: res.user.id,}})
                  .then(competencies => {
                    if(competencies.data.length>0){
                  //    this.$router.push({name: 'user-home'});
                      window.location.replace("/user/home");
                    }else{
                    //  this.$router.push({name: 'add-skill'});
                      window.location.replace("/user/add-skill");
                    }
                    console.log('res',competencies.data);

                  }).catch();
             // this.$router.push({name: 'add-skill'});
            } else if (res.user.userType === "coach") {


              //  this.$router.push({name: 'user-profile'});
              window.location.replace("/user/profile/view");
            } else if (res.user.userType === "admin") {

              this.$router.push({name: 'admin-user-list'});
            } else if (res.company[0].name !== "") {
              this.$router.push({name: 'admin-user-list'});
            }
          } })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
          console.log("login failed", error);
        });
    },
    forget_password() {
      // console.log('models', models)


    const   payload ={
      email:this.forget_password_email,
      flag:'forgetPasswordEmailSent'
      }

      this.$store
        .dispatch("userManagement/EmailExist", payload)
        .then(res => {
          console.log(" email exist", res);
          if(!Object.keys(res.data).length){
            this.$vs.notify({
              title: i18n.t('notification.user.auth.EmailExist.error.e1'),
              text:  i18n.t('notification.user.auth.EmailExist.error.e2'),
              color: "danger"
            });
          }else{
            this.$vs.notify({
              title: i18n.t('notification.user.auth.EmailExist.passwordReset.r1'),
              text:  i18n.t('notification.user.auth.EmailExist.passwordReset.r2'),
              color: "primary"
            });
          }
        })
        .catch(err => {
          console.log("Email  is not  registered", err);
          this.$vs.notify({
            title: i18n.t('notification.user.auth.EmailExist.error.e1'),
            text:  i18n.t('notification.user.auth.EmailExist.error.e2'),
            color: "danger"
          });
        });
    },
    registerUser () {
      // to be used later
      // if (!this.checkLogin()) return;
      this.$router.push("/user/auth/register").catch(() => {});
    }
  }
};
</script>
